import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Form from "./pages/Form";
import WelcomePage from "./pages/WelcomePage";

const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => (
  <BrowserRouter>
    {/* Scroll to top on route change */}
    <ScrollToTopOnRouteChange />

    <Routes>
      <Route path="/:id/:id2" element={<WelcomePage />} />
      <Route path="form/:id/:id2" element={<Form />} />
    </Routes>
  </BrowserRouter>
);

export default App;
